import Nav from "@/components/Nav";
import Fees from "@/components/Fees";
import Footer from "@/components/Footer";

export default function FeesPage() {
  return (
    <div data-testid="fees-page" className="bg-ivory">
      <Nav />
      <div className="pt-20">
        <Fees />
      </div>
      <Footer />
    </div>
  );
}
